import VoiceSettings from "./VoiceSettings.container";
export default VoiceSettings;
